import { createAsyncThunk } from '@reduxjs/toolkit';
import * as QuickBooksApi from '@sophocles/api/quickbooks';

export const loadQuickBooks = createAsyncThunk('quickbooks/load', async (_, { rejectWithValue }) => {
  const data = { authorizationUrl: null, company: null, customers: [] };

  try {
    data.authorizationUrl = await QuickBooksApi.fetchQuickBooksAuthorizationUrl();
  } catch (e) {
    return rejectWithValue(e.response.data);
  }

  try {
    data.company = await QuickBooksApi.fetchQuickBooksCompany();
  } catch (e) {
    data.company = null;
  }

  if (data.company != null) {
    try {
      data.customers = await QuickBooksApi.fetchQuickBooksCustomers();
    } catch (e) {
      data.customers = [];
    }
  }

  return data;
});

export const loadQuickBooksCustomers = createAsyncThunk(`quickbooks/customers/load`, async (_, { rejectWithValue }) => {
  try {
    const data = await QuickBooksApi.fetchQuickBooksCustomers();
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});

export const loadQuickBooksAssociations = createAsyncThunk(
  `quickbooks/associations/load`,
  async (accountId, { rejectWithValue }) => {
    try {
      const data = await QuickBooksApi.fetchQuickBooksCustomerAssociations(accountId);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const createQuickBooksAssociation = createAsyncThunk(
  `quickbooks/associations/create`,
  async ({ quickBooksCustomerId, accountId, siteGroupId }, { rejectWithValue }) => {
    try {
      const data = await QuickBooksApi.associateQuickBooksCustomer(quickBooksCustomerId, accountId, siteGroupId);
      return { quickBooksCustomerId, accountId, siteGroupId, associated: data };
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const createQuickBooksInvoice = createAsyncThunk(
  `quickbooks/invoices/create`,
  async ({ invoiceId, isAnnual }, { rejectWithValue }) => {
    try {
      const data = await QuickBooksApi.createQuickBooksInvoice(invoiceId, isAnnual);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const disassociateQuickBooksCustomer = createAsyncThunk(
  'quickbooks/associations/delete',
  async (siteGroupId, { rejectWithValue }) => {
    try {
      const data = await QuickBooksApi.disassociateQuickBooksCustomer(siteGroupId);
      return { siteGroupId, disassociated: data };
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);
